import { SchemaFieldProperty } from './schema-field-property';

/* istanbul ignore file */
export class Properties {
    [key: string]: SchemaFieldProperty;
}
